import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ButtonWithLink from '@gameday/react-components/components/ButtonWithLink'
import Paper from '@gameday/react-components/components/Paper'
import theme, { rem } from '@gameday/react-components/utils/theme'
import styled from 'styled-components'

import SmallLogoFooter from '../SmallLogoFooter'
import styles from './styles.scss'

const StyledPageWrap = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  width: 100%;
  text-align: center;

  .MuiPaper-root {
    padding: ${rem(42)} ${rem(34)};
    background: ${theme.colors.white};
    ${theme.breakpoints.down(400)} {
      padding: ${rem(30)} ${rem(20)};
    }
  }
  > div:first-of-type {
    min-height: 0;
    padding: ${rem(60)} ${rem(30)} ${rem(30)} ${rem(30)};
  }
`

const SuccessPage = ({ headingMessage, hideIcon, subHeadingMessage, history, redirectLoginPath }) => (
  <StyledPageWrap>
    <Paper>
      {!hideIcon ? <FontAwesomeIcon className={styles.checkIcon} icon="check-circle" /> : null}
      <h2>{headingMessage}</h2>
      {subHeadingMessage && <h3>{subHeadingMessage}</h3>}
      <ButtonWithLink
        id="submit-button"
        type="submit"
        onClick={() => history.push(redirectLoginPath)}
        label="Go back to Login"
        color="primary"
        variant="contained"
        style={{ marginTop: 30 }}
      />
    </Paper>
    <SmallLogoFooter />
  </StyledPageWrap>
)

SuccessPage.defaultProps = {
  subHeadingMessage: '',
}

export default SuccessPage
